export default {
    data() {
        return {
            language: 'en',
        };
    },
    async created() {
        await this.getCurrentLanguage();
    },
    methods: {
        async getCurrentLanguage() {
            await this.$store.dispatch('localization/getLanguages');
            let languages = this.$store.getters['localization/getLanguages'];
            this.language = languages && languages.selected_short_name ? languages.selected_short_name : this.language;
        },
        async openGoogleTranslate(sourceText) {
            let url = "https://translate.google.com/?source=gtx&sl=auto&tl=" + this.language + "&text=" + encodeURI(sourceText);
            window.open(url, "_blank").focus();
        },
    }
};